import { IndexTable, Text, Link } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { StatusBadge } from '../Common/StatusBadge';

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

const DeliveriesDash = ({ data }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (data) {
      setRows(data.slice(0, 5).map((r, k) => rowMarkup(r, k)));
    }
  }, [data]);

  const headingMarkup = [
    { title: 'Envío' },
    { title: 'Fecha Factura' },
    { title: 'Depósito' },
    { title: 'Stock' },
    { title: 'Estado' }
  ];

  const rowMarkup = ({ id, name, invoiceDate, deposit, stockQtyExpected, status }, index) => (
    <IndexTable.Row id={id} key={id} position={index}>
      <IndexTable.Cell>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Link dataPrimaryLink url={`/deliveries/${id}`}>
            <Text variant="bodyMd" fontWeight="bold" as="span">#{id}</Text>
          </Link>
          <Text variant="bodySm" as="span" color="subdued">{name}</Text>
        </div>
      </IndexTable.Cell>
      <IndexTable.Cell>{formatDate(invoiceDate)}</IndexTable.Cell>
      <IndexTable.Cell>
        <Text variant="bodySm" as="span">{deposit?.name || '-'}</Text>
      </IndexTable.Cell>
      <IndexTable.Cell>{stockQtyExpected}</IndexTable.Cell>
      <IndexTable.Cell>
        <StatusBadge type="delivery" status={status} />
      </IndexTable.Cell>
    </IndexTable.Row>
  );

  if (!data || data.length === 0) return null;

  return (
    <IndexTable
      resourceName={{ singular: 'recepción', plural: 'recepciones' }}
      itemCount={rows.length}
      headings={headingMarkup}
      selectable={false}
    >
      {rows}
    </IndexTable>
  );
};

export default DeliveriesDash;

